import type { SequenceStepType, SequenceTriggerType } from "@unbox/db";

/**
 * Kept out of `repo.ts` so a Temporal workflow can import it. `repo.ts` reaches Drizzle and `pg`,
 * which the workflow sandbox cannot bundle.
 */
export const DUE_STEPS_LIMIT = 500;

// Step types that perform a GMV Max action, so they can't run without TikTok Ads
// authorised (per-policy equivalent: SAFETY_POLICY_GMV_MAX_ONLY).
export const GMV_MAX_STEP_TYPES = new Set<SequenceStepType>(["remove_from_gmv_max", "add_to_gmv_max_campaign"]);

export const COLLAB_TRIGGER_TYPES = [
  "collaboration_invite",
  "sample_delivered",
  "creator_dormant",
  "first_collab_video",
] as const satisfies SequenceTriggerType[];

export type CollabTriggerType = (typeof COLLAB_TRIGGER_TYPES)[number];
